<template>
  <!-- Global Loader -->
  <div v-if="loading" id="global-loader">
    <div class="whirly-loader"></div>
  </div>

  <!-- Dynamic Layout -->
  <component :is="layout">
    <router-view />
  </component>
</template>

<script setup>
import { computed, ref, provide, onMounted } from 'vue'
import { useRoute } from 'vue-router'
import MainLayout from './components/layouts/MainLayout.vue'
import PosLayout from './components/layouts/PosLayout.vue'

const route = useRoute()

const layout = computed(() => {
  const layoutName = route.meta.layout || 'main'
  return layoutName === 'pos' ? PosLayout : MainLayout
})

// Global loading state.
const loading = ref(false)

// Make the loader globally injectable.
provide('globalLoading', (val) => {
  loading.value = val
})

onMounted(() => {
  const loginEvent = new CustomEvent('vueLoaded', {
    detail: { username: 'john_doe' },
    bubbles: true,    // Allows event to bubble up
    cancelable: true  // Allows preventDefault()
  });

  // 3. Emit the event
  document.dispatchEvent(loginEvent);
})

</script>
